"use strict";

var _fontawesomeSvgCore = require("@fortawesome/fontawesome-svg-core");
var Regular = _interopRequireWildcard(require("./regular"));
var Solid = _interopRequireWildcard(require("./solid"));
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
// import * as Brand from './brand'

const TCIcons = () => {
  [Object.values(Regular),
  // Object.values(Brand),
  Object.values(Solid)].forEach(icon => {
    _fontawesomeSvgCore.library.add(icon);
  });
};
TCIcons();